import Vue from 'vue';
import moment from 'moment';
import axios from '@didi/dajax';
export default Vue.extend({
    props: {
        settleOrderId: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            downLoading: false,
            statementNo: '',
            statementId: '',
            showMoneyInfo: false,
            historyLeft: {
                label: '目前与[--】推广费结算结余金额',
                value: '',
            },
            feeBackChannel: '',
            leftMoneyInfo: [
                [
                    {
                        label: '推广费实收金额',
                        value: '',
                    },
                ],
                [
                    {
                        label: '收款日期',
                        value: '',
                    },
                ],
            ],
            auditStep: '',
            incomeAmount: '',
            basicData: [
                [
                    {
                        label: '结算单编号',
                        value: '',
                    },
                    {
                        label: '结算人',
                        value: '',
                    },
                ],
                [
                    {
                        label: '结算状态',
                        value: '',
                    },
                    {
                        label: '结算时间',
                        value: '',
                    },
                ],
            ],
            basicCheckData: [
                [
                    {
                        label: '对账单编号',
                        value: '',
                    },
                    {
                        label: '总保费',
                        value: '',
                    },
                    {
                        label: '本期费用条数',
                        value: '',
                    },
                ],
                [
                    {
                        label: '开票渠道',
                        value: '',
                    },
                    {
                        label: '推广费',
                        value: '',
                    },
                ],
                [
                    {
                        label: '申报日期',
                        value: '',
                    },
                    {
                        label: '账单截止日期',
                        value: '',
                    },
                ],
            ],
        };
    },
    methods: {
        showLoading: function () {
            window.loading = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
        },
        hideLoading: function () {
            window.loading && window.loading.close();
        },
        showPageInfo: function (res) {
            this.statementId = res.statement.id;
            this.statementNo = res.statement.statementNo;
            // console.log('SettleOrderDetail showPageInfo:', this.statementId)
            // 结算单
            this.basicData[0][0].value = res.settlementNo;
            this.basicData[0][1].value =
                res.payer && res.payer.name ? res.payer.name : '--';
            this.basicData[1][0].value = res.settlementStatusDes;
            // 结算时间 majinjin
            this.basicData[1][1].value = res.payTime ? res.payTime : '--';
            this.basicCheckData[0][0].value = res.statement.statementNo;
            this.basicCheckData[0][1].value = '￥' + res.statement.sumOrderAmount;
            this.basicCheckData[0][2].value = res.statement.sumBillNumber + '条';
            this.basicCheckData[1][0].value = res.channelName;
            this.basicCheckData[1][1].value = '￥' + res.statement.sumAmount;
            this.basicCheckData[2][0].value = res.statement.createdAt;
            this.basicCheckData[2][1].value = moment(res.statement.endTime).format('YYYY-MM-DD');
            // majinjin
            this.incomeAmount = '￥' + res.statement.sumAmount;
            this.historyLeft.label = "\u76EE\u524D\u4E0E\u3010" + res.channelName + "\u3011\u63A8\u5E7F\u8D39\u7ED3\u7B97\u7ED3\u4F59\u91D1\u989D";
            this.historyLeft.value = res.accountBalance + '元';
            this.feeBackChannel = res.channelName;
            if (res.payer) {
                this.leftMoneyInfo[0][0].value = res.payAmount;
                this.leftMoneyInfo[1][0].value = res.payTime ? res.payTime : '--';
            }
            else {
                this.leftMoneyInfo[0][0].value = '--';
                this.leftMoneyInfo[1][0].value = '--';
            }
            this.auditStep = res.statusName;
        },
        querySettleOrderDetail: function () {
            var params = {
                settlementId: this.settleOrderId,
            };
            return this.$request({
                url: '/proxy/carInsurance/channelBill/querySettlementDetail',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                return res;
            });
        },
        downloadCheckOrders: function () {
            var _this = this;
            this.downLoading = true;
            var params = {
                statementId: this.statementId,
            };
            return axios({
                method: 'post',
                url: '/proxy/carInsExport/channelBill/downloadStatement',
                data: params,
                needEncrypt: true,
                responseType: 'blob',
            })
                .then(function (res) {
                _this.downLoading = false;
                var fileName = "\u5BF9\u8D26\u5355_" + _this.statementNo + ".xlsx";
                _this.saveExportFile(fileName, res);
                return res;
            })
                .catch(function () {
                _this.downLoading = false;
                _this.$message({
                    message: '对账单下载失败',
                    type: 'error',
                });
            });
        },
        saveExportFile: function (fileName, response) {
            if (!response) {
                console.error('下载失败！');
            }
            var url = window.URL.createObjectURL(new Blob([response.data]));
            var link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        },
    },
    created: function () {
        var _this = this;
        this.querySettleOrderDetail().then(function (res) {
            if (res) {
                _this.showPageInfo(res.data);
            }
        });
    },
});
